import React, { Fragment } from 'react'
import { Route } from 'react-router-dom';
import { TappingCheckListReport } from './Pages/listing';

export const TappingCheckListReportRoutes = ({ match }) => (
    <Fragment>
        <Route exact path={`${match.path}`} component={TappingCheckListReport} />
    </Fragment>
)